module.exports = __webpack_public_path__ + "static/media/dashboard-icon.01314c78.png";